module.exports = __webpack_public_path__ + "img/55.9114804c.svg";